// extracted by mini-css-extract-plugin
module.exports = {"audio-talk":"trtcAudio_audio-talk__25kJd","stream-container":"trtcAudio_stream-container__2fEmv","stream-item":"trtcAudio_stream-item__6_D_5"};